"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  BrowserPageLayout: ['browser-page-layout', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.75a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-2.25,2A.25.25,0,0,1,22,7v5.5a.25.25,0,0,1-.25.25h-12a.25.25,0,0,1-.25-.25V7a.25.25,0,0,1,.25-.25Zm-12.1-3a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.75Zm-3.5,0a.966.966,0,0,1,1.692,0A.969.969,0,0,1,8,4.25a.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0A.969.969,0,0,1,6,4.25.969.969,0,0,1,6.154,3.75Zm-3.562.092A1,1,0,0,1,3.5,3.25a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.979.979,0,0,1,2.592,3.842ZM8,20a.25.25,0,0,1-.25.25H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h5.5A.25.25,0,0,1,8,7Zm14-.75a1,1,0,0,1-1,1H9.75A.25.25,0,0,1,9.5,20V14.5a.25.25,0,0,1,.25-.25h12a.25.25,0,0,1,.25.25Z']],
  BrowserPageText: ['browser-page-text', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.000 8.250 L20.000 8.250 L20.000 11.250 L4.000 11.250 Z', 'M13.25,12.75a.75.75,0,0,0,0,1.5h6a.75.75,0,0,0,0-1.5Z', 'M19.25,16.25h-6a.75.75,0,0,0,0,1.5h6a.75.75,0,0,0,0-1.5Z', 'M4.000 12.750 L11.000 12.750 L11.000 19.250 L4.000 19.250 Z', 'M24,4.75a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.75Zm-3.5,0a.966.966,0,0,1,1.692,0A.969.969,0,0,1,8,4.25a.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0A.969.969,0,0,1,6,4.25.969.969,0,0,1,6.154,3.75Zm-3.562.092A1,1,0,0,1,3.5,3.25a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.979.979,0,0,1,2.592,3.842ZM22,19.25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  BrowserPageMedia: ['browser-page-media', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.75a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.75Zm-3.5,0a.966.966,0,0,1,1.692,0A.969.969,0,0,1,8,4.25a.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0A.969.969,0,0,1,6,4.25.969.969,0,0,1,6.154,3.75Zm-3.562.092A1,1,0,0,1,3.5,3.25a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.979.979,0,0,1,2.592,3.842ZM22,19.25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z', 'M3,16.5a1.251,1.251,0,0,0,1.25,1.25h6A1.251,1.251,0,0,0,11.5,16.5v-6a1.252,1.252,0,0,0-1.25-1.25h-6A1.252,1.252,0,0,0,3,10.5ZM4.5,11a.25.25,0,0,1,.25-.25h5A.25.25,0,0,1,10,11v3.839a.25.25,0,0,1-.465.128L8.148,12.645a.5.5,0,0,0-.817-.058L4.944,15.528a.25.25,0,0,1-.444-.157Z', 'M12.5,16.5a1.251,1.251,0,0,0,1.25,1.25h6A1.251,1.251,0,0,0,21,16.5v-6a1.252,1.252,0,0,0-1.25-1.25h-6A1.252,1.252,0,0,0,12.5,10.5ZM14,11a.25.25,0,0,1,.25-.25h5a.25.25,0,0,1,.25.25v3.839a.25.25,0,0,1-.465.128l-1.387-2.322a.5.5,0,0,0-.817-.058l-2.387,2.941A.25.25,0,0,1,14,15.371Z']],
  BrowserPageMail: ['browser-page-mail', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.5a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v15a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3ZM3,5A1,1,0,1,1,4,6,1,1,0,0,1,3,5ZM6,5A1,1,0,1,1,7,6,1,1,0,0,1,6,5ZM9,5a1,1,0,1,1,1,1A1,1,0,0,1,9,5ZM22,19.5a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V9a.5.5,0,0,1,.5-.5h19A.5.5,0,0,1,22,9Z', 'M3.500 10.500 L9.500 10.500 L9.500 18.500 L3.500 18.500 Z', 'M12.5,15.25h7a.75.75,0,0,0,0-1.5h-7a.75.75,0,0,0,0,1.5Z', 'M12.5,12.25h7a.75.75,0,0,0,0-1.5h-7a.75.75,0,0,0,0,1.5Z', 'M12.5,18.25h7a.75.75,0,0,0,0-1.5h-7a.75.75,0,0,0,0,1.5Z']],
  MonitorTouch: ['monitor-touch', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.664,18.164a1.284,1.284,0,0,0-.894-1.521l-3.786-1.1a.249.249,0,0,1-.181-.24V11.76a1,1,0,0,0-2,0V18.1a.25.25,0,0,1-.423.18c-1.451-1.392-3.181-.706-2.077.981l2.316,3.372a.25.25,0,0,0,.206.108h5.78a.249.249,0,0,0,.246-.2Z', 'M11.8,22.26a1,1,0,0,0,0-2h-.25a.25.25,0,0,1-.25-.25V18.485a.25.25,0,0,1,.2-.245,1,1,0,0,0-.2-1.98H2.8a.5.5,0,0,1-.5-.5v-12a.5.5,0,0,1,.5-.5h18a.5.5,0,0,1,.5.5v10.5a1,1,0,1,0,2,0v-11a2,2,0,0,0-2-2H2.3a2,2,0,0,0-2,2v13a2,2,0,0,0,2,2H9.052a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H6.8a1,1,0,0,0,0,2Z']],
  CodeWrite1: ['code-write-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.6,20.652l-.5,2.5a.5.5,0,0,0,.491.6.457.457,0,0,0,.1-.01l2.5-.5a.489.489,0,0,0,.256-.136l6.5-6.5A1.914,1.914,0,0,0,20.234,13.9l-6.5,6.5A.5.5,0,0,0,13.6,20.652Z', 'M1.5,23.25h9.647a.489.489,0,0,0,.479-.392l.5-2.5a1.991,1.991,0,0,1,.547-1.022l4.68-4.681A.5.5,0,0,0,17.5,14.3V4.664a1,1,0,0,0-.293-.707L13.794.543A1,1,0,0,0,13.087.25H1.5a1,1,0,0,0-1,1v21A1,1,0,0,0,1.5,23.25Zm2-11.5a.5.5,0,0,1,.5-.5H8a.5.5,0,0,1,.5.5v1a.25.25,0,0,0,.25.25H10.5a.251.251,0,0,0,.25-.25v-6a.251.251,0,0,0-.25-.25H8.751a.25.25,0,0,0-.25.25v1a.5.5,0,0,1-.5.5H4a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5H8a.5.5,0,0,1,.5.5v1a.25.25,0,0,0,.25.25H10.5a1.752,1.752,0,0,1,1.75,1.75v2A.25.25,0,0,0,12.5,9H14a.75.75,0,0,1,0,1.5H12.5a.25.25,0,0,0-.25.25v2A1.752,1.752,0,0,1,10.5,14.5H8.751a.25.25,0,0,0-.25.25v1a.5.5,0,0,1-.5.5H4a.5.5,0,0,1-.5-.5Z']],
  BrowserPageText2: ['browser-page-text-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3ZM9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5A.966.966,0,0,1,9.654,3,.969.969,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2Zm-3.5,0A.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5a.969.969,0,0,1-.154.5A.966.966,0,0,1,6.154,3,.969.969,0,0,1,6,2.5.969.969,0,0,1,6.154,2Zm-3.562.092A1,1,0,0,1,3.5,1.5a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5A.966.966,0,0,1,2.654,3,.969.969,0,0,1,2.5,2.5.979.979,0,0,1,2.592,2.092ZM3,22a1,1,0,0,1-1-1V5.25A.25.25,0,0,1,2.25,5h6a.25.25,0,0,1,.25.25v16.5a.25.25,0,0,1-.25.25Zm19-1a1,1,0,0,1-1,1H10.25a.25.25,0,0,1-.25-.25V5.25A.25.25,0,0,1,10.25,5h11.5a.25.25,0,0,1,.25.25Z', 'M12.500 7.000 L19.500 7.000 L19.500 12.500 L12.500 12.500 Z', 'M3.5,7.25A.75.75,0,0,0,4.25,8h2a.75.75,0,0,0,0-1.5h-2A.75.75,0,0,0,3.5,7.25Z', 'M5.5,12h.75a.75.75,0,0,0,0-1.5H5.5a.75.75,0,0,0,0,1.5Z', 'M4.25,16h2a.75.75,0,0,0,0-1.5h-2a.75.75,0,0,0,0,1.5Z', 'M5.5,20h.75a.75.75,0,0,0,0-1.5H5.5a.75.75,0,0,0,0,1.5Z', 'M12.500 14.500 L19.500 14.500 L19.500 20.000 L12.500 20.000 Z']],
  MonitorCodeSend: ['monitor-code-send', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.05,24h8a1.752,1.752,0,0,0,1.75-1.75v-8a1.752,1.752,0,0,0-1.75-1.75h-8A1.752,1.752,0,0,0,.3,14.25v8A1.752,1.752,0,0,0,2.05,24ZM1.8,14.25A.25.25,0,0,1,2.05,14h8a.251.251,0,0,1,.25.25v8a.251.251,0,0,1-.25.25h-8a.25.25,0,0,1-.25-.25Z', 'M5.019,20.78a.75.75,0,0,0,1.061,0l2-2a.749.749,0,0,0,0-1.06l-2-2a.75.75,0,1,0-1.061,1.06l1.47,1.47-1.47,1.47A.751.751,0,0,0,5.019,20.78Z', 'M14.494,20.5H21a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V9.518A1,1,0,0,0,2,9.5V5.25A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V17.5a1,1,0,0,1-1,1H14.5A1,1,0,0,0,14.494,20.5ZM9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5A.966.966,0,0,1,9.654,3,.969.969,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2Zm-3.5,0A.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5a.969.969,0,0,1-.154.5A.966.966,0,0,1,6.154,3,.969.969,0,0,1,6,2.5.969.969,0,0,1,6.154,2Zm-3.562.092A1,1,0,0,1,3.5,1.5a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5A.966.966,0,0,1,2.654,3,.969.969,0,0,1,2.5,2.5.979.979,0,0,1,2.592,2.092Z']],
  MonitorPage: ['monitor-page', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,3V14.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V3A1,1,0,0,0,1,2H1A1,1,0,0,0,0,3V16.5a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25v-2a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3V3a1,1,0,0,0-1-1h0A1,1,0,0,0,22,3Z', 'M5.5,12.5V5.248A.25.25,0,0,1,5.75,5h12.5a.25.25,0,0,1,.25.25V12.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V3a3,3,0,0,0-3-3H6.5a3,3,0,0,0-3,3v9.5a1,1,0,0,0,1,1h0A1,1,0,0,0,5.5,12.5ZM13.154,2a.966.966,0,0,1,1.692,0A.972.972,0,0,1,15,2.5a.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0A.969.969,0,0,1,13,2.5.972.972,0,0,1,13.154,2Zm-3.5,0a.966.966,0,0,1,1.692,0,.972.972,0,0,1,.154.5.969.969,0,0,1-.154.5A.966.966,0,0,1,9.654,3,.969.969,0,0,1,9.5,2.5.972.972,0,0,1,9.654,2ZM6.092,2.09A1,1,0,0,1,7,1.5a.985.985,0,0,1,.846.5A.972.972,0,0,1,8,2.5a.969.969,0,0,1-.154.5A.966.966,0,0,1,6.154,3,.969.969,0,0,1,6,2.5.979.979,0,0,1,6.092,2.09Z', 'M16.25,6.5h-4a.75.75,0,1,0,0,1.5h4a.75.75,0,0,0,0-1.5Z', 'M16.25,10H8.75a.75.75,0,0,0,0,1.5h7.5a.75.75,0,0,0,0-1.5Z']],
  WebsiteBuild: ['website-build', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M-.1,19a3,3,0,0,0,3,3H20.85a3,3,0,0,0,3-3V13.5a.975.975,0,0,0-.6-.9.25.25,0,0,1-.151-.23V10a.25.25,0,0,1,.25-.25.75.75,0,0,0,0-1.5A.25.25,0,0,1,23.1,8V5.5a.25.25,0,0,1,.25-.25.75.75,0,0,0,0-1.5.25.25,0,0,1-.25-.25V3a.75.75,0,0,0-1.5,0v.5a.25.25,0,0,1-.25.25H19.4a.25.25,0,0,1-.25-.25V3a.75.75,0,0,0-1.5,0v.5a.25.25,0,0,1-.25.25H15.65a.25.25,0,0,1-.25-.25V3a1,1,0,0,0-1-1H2.9a3,3,0,0,0-3,3ZM19.15,5.5a.25.25,0,0,1,.25-.25h1.95a.25.25,0,0,1,.25.25V8a.25.25,0,0,1-.25.25H19.4A.25.25,0,0,1,19.15,8Zm0,4.5a.25.25,0,0,1,.25-.25h1.95a.25.25,0,0,1,.25.25v2.25a.25.25,0,0,1-.25.25H19.4a.25.25,0,0,1-.25-.25ZM15.4,5.5a.25.25,0,0,1,.25-.25H17.4a.25.25,0,0,1,.25.25V8a.25.25,0,0,1-.25.25H15.65A.25.25,0,0,1,15.4,8Zm0,4.5a.25.25,0,0,1,.25-.25H17.4a.25.25,0,0,1,.25.25v2.25a.25.25,0,0,1-.25.25H15.65a.25.25,0,0,1-.25-.25ZM9.553,4a.967.967,0,0,1,1.693,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5A.984.984,0,1,1,9.553,4Zm-3.5,0A.967.967,0,0,1,7.746,4a.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5A.984.984,0,1,1,6.053,4ZM2.4,4.5a.979.979,0,0,1,.092-.408A.98.98,0,0,1,4.246,4a.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5A1,1,0,0,1,2.4,4.5ZM1.9,7.25A.25.25,0,0,1,2.15,7h11a.25.25,0,0,1,.25.25V12.5a2,2,0,0,0,2,2h6.2a.25.25,0,0,1,.25.25V19a1,1,0,0,1-1,1H2.9a1,1,0,0,1-1-1Z']],
  BrowserHand: ['browser-hand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.025,24a1,1,0,0,0,1-1V15.75a1,1,0,0,0-2,0V23A1,1,0,0,0,1.025,24Z', 'M15.525,19.5H6.4a.625.625,0,1,1,0-1.25H8.925a1,1,0,0,0,.92-1.392A2.233,2.233,0,0,0,7.789,15.5H3.525a.5.5,0,0,0-.5.5v6.5a.5.5,0,0,0,.5.5H14.289a2.238,2.238,0,0,0,2.236-2.236V20.5A1,1,0,0,0,15.525,19.5Z', 'M20.975,0h-13a3,3,0,0,0-3,3v8.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V5.25A.25.25,0,0,1,7.225,5h14.5a.25.25,0,0,1,.25.25V14a1,1,0,0,1-1,1h-7.5a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h7.5a3,3,0,0,0,3-3V3A3,3,0,0,0,20.975,0ZM9.322,3A.967.967,0,0,1,7.629,3a.969.969,0,0,1-.154-.5.979.979,0,0,1,.092-.408A.981.981,0,0,1,9.322,2a.977.977,0,0,1,.153.5A.977.977,0,0,1,9.322,3Zm3.5,0a.967.967,0,0,1-1.693,0,.969.969,0,0,1-.154-.5.969.969,0,0,1,.154-.5.967.967,0,0,1,1.693,0,.977.977,0,0,1,.153.5A.977.977,0,0,1,12.822,3Zm3.5,0a.967.967,0,0,1-1.693,0,.969.969,0,0,1-.154-.5.969.969,0,0,1,.154-.5.967.967,0,0,1,1.693,0,.977.977,0,0,1,.153.5A.977.977,0,0,1,16.322,3Z']],
  BrowserPageAccount: ['browser-page-account', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.75a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.75Zm-3.5,0a.966.966,0,0,1,1.692,0A.969.969,0,0,1,8,4.25a.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0A.969.969,0,0,1,6,4.25.969.969,0,0,1,6.154,3.75Zm-3.562.092A1,1,0,0,1,3.5,3.25a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.979.979,0,0,1,2.592,3.842ZM22,19.25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z', 'M5.321,18.25h6.858A1.288,1.288,0,0,0,13.5,17V10a1.289,1.289,0,0,0-1.321-1.25H5.321A1.289,1.289,0,0,0,4,10v7A1.288,1.288,0,0,0,5.321,18.25ZM5.5,10.5a.25.25,0,0,1,.25-.25h6a.25.25,0,0,1,.25.25v6a.25.25,0,0,1-.25.25h-.391a.249.249,0,0,1-.241-.184A2.587,2.587,0,0,0,8.75,14.5a2.587,2.587,0,0,0-2.368,2.066.249.249,0,0,1-.241.184H5.75a.25.25,0,0,1-.25-.25Z', 'M7.250 13.000 A1.500 1.500 0 1 0 10.250 13.000 A1.500 1.500 0 1 0 7.250 13.000 Z', 'M15,10a.75.75,0,0,0,.75.75h4a.75.75,0,0,0,0-1.5h-4A.75.75,0,0,0,15,10Z', 'M15.75,14.25h4a.75.75,0,0,0,0-1.5h-4a.75.75,0,0,0,0,1.5Z', 'M15.75,17.75h4a.75.75,0,0,0,0-1.5h-4a.75.75,0,0,0,0,1.5Z']],
  BrowserCom: ['browser-com', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.550 15.500 A1.000 1.000 0 1 0 5.550 15.500 A1.000 1.000 0 1 0 3.550 15.500 Z', 'M9.55,16.75a.75.75,0,0,0,0-1.5A1.25,1.25,0,0,1,8.3,14V13a1.251,1.251,0,0,1,1.25-1.25.75.75,0,0,0,0-1.5A2.753,2.753,0,0,0,6.8,13v1A2.752,2.752,0,0,0,9.55,16.75Z', 'M13.05,16.75A1.752,1.752,0,0,0,14.8,15V12a1.75,1.75,0,0,0-3.5,0v3A1.752,1.752,0,0,0,13.05,16.75ZM12.8,12a.25.25,0,0,1,.5,0v3c0,.275-.5.275-.5,0Z', 'M16.55,16.75A.75.75,0,0,0,17.3,16V13.915a.058.058,0,0,1,.042-.055.057.057,0,0,1,.064.026.781.781,0,0,0,1.287,0,.058.058,0,0,1,.065-.026.058.058,0,0,1,.042.055V16a.75.75,0,0,0,1.5,0V11a.751.751,0,0,0-1.394-.386l-.642,1.071a.249.249,0,0,1-.214.121.252.252,0,0,1-.215-.121l-.642-1.071A.75.75,0,0,0,15.8,11v5A.75.75,0,0,0,16.55,16.75Z', 'M24,4.75a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.75Zm-3.5,0a.966.966,0,0,1,1.692,0A.969.969,0,0,1,8,4.25a.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0A.969.969,0,0,1,6,4.25.969.969,0,0,1,6.154,3.75Zm-3.562.092A1,1,0,0,1,3.5,3.25a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.979.979,0,0,1,2.592,3.842ZM22,19.25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  MonitorWww: ['monitor-www', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,23.75a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25V20a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3V2.839A2.548,2.548,0,0,0,21.5.25H2.5A2.548,2.548,0,0,0,0,2.839V16.75a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2ZM2,2.839a.551.551,0,0,1,.5-.589h19a.551.551,0,0,1,.5.589V14.75a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5Z', 'M8,6a.75.75,0,0,0-.75.75V8.1A5.279,5.279,0,0,1,7.2,8.84a.125.125,0,0,1-.115.107.126.126,0,0,1-.129-.09l-.232-.813a.75.75,0,0,0-1.442,0l-.232.812A.125.125,0,0,1,4.8,8.84,5.279,5.279,0,0,1,4.75,8.1V6.75a.75.75,0,0,0-1.5,0V8.1A6.73,6.73,0,0,0,3.732,10.6L4.3,12.028a.73.73,0,0,0,.734.471.749.749,0,0,0,.683-.543L5.88,11.4a.125.125,0,0,1,.24,0l.159.556a.749.749,0,0,0,.683.543H7a.747.747,0,0,0,.7-.472L8.268,10.6A6.73,6.73,0,0,0,8.75,8.1V6.75A.75.75,0,0,0,8,6Z', 'M14,6a.75.75,0,0,0-.75.75V8.1a5.279,5.279,0,0,1-.053.745.125.125,0,0,1-.115.107.126.126,0,0,1-.129-.09l-.232-.813a.75.75,0,0,0-1.442,0l-.232.812A.125.125,0,0,1,10.8,8.84,5.279,5.279,0,0,1,10.75,8.1V6.75a.75.75,0,0,0-1.5,0V8.1A6.73,6.73,0,0,0,9.732,10.6l.572,1.426a.729.729,0,0,0,.734.471.749.749,0,0,0,.683-.543l.159-.556a.125.125,0,0,1,.24,0l.159.556a.749.749,0,0,0,.683.543H13a.747.747,0,0,0,.7-.472l.572-1.426A6.73,6.73,0,0,0,14.75,8.1V6.75A.75.75,0,0,0,14,6Z', 'M20,6a.75.75,0,0,0-.75.75V8.1a5.279,5.279,0,0,1-.053.745.125.125,0,0,1-.115.107.126.126,0,0,1-.129-.09l-.232-.813a.75.75,0,0,0-1.442,0l-.232.812A.125.125,0,0,1,16.8,8.84,5.279,5.279,0,0,1,16.75,8.1V6.75a.75.75,0,0,0-1.5,0V8.1a6.73,6.73,0,0,0,.482,2.507l.572,1.426a.729.729,0,0,0,.734.471.749.749,0,0,0,.683-.543l.159-.556a.125.125,0,0,1,.24,0l.159.556a.749.749,0,0,0,.683.543H19a.747.747,0,0,0,.7-.472l.572-1.426A6.73,6.73,0,0,0,20.75,8.1V6.75A.75.75,0,0,0,20,6Z']],
  BrowserPageHierarchy: ['browser-page-hierarchy', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.75a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.75Zm-3.5,0a.966.966,0,0,1,1.692,0A.969.969,0,0,1,8,4.25a.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0A.969.969,0,0,1,6,4.25.969.969,0,0,1,6.154,3.75Zm-3.562.092A1,1,0,0,1,3.5,3.25a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.979.979,0,0,1,2.592,3.842ZM22,19.25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z', 'M4.05,17.25a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-2a1,1,0,0,0-.8-.98.249.249,0,0,1-.2-.245V11.75a.5.5,0,0,1,.5-.5h2.64a.25.25,0,0,1,.207.111,2.005,2.005,0,0,0,.987.767.251.251,0,0,1,.166.236V14a.25.25,0,0,1-.25.25h-.25a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-2a1,1,0,0,0-1-1H12.8a.25.25,0,0,1-.25-.25V12.364a.249.249,0,0,1,.166-.236,2,2,0,0,0,.986-.767.25.25,0,0,1,.208-.111h2.64a.5.5,0,0,1,.5.5v2.275a.25.25,0,0,1-.2.245,1,1,0,0,0-.8.98v2a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-2a1,1,0,0,0-1-1H18.3a.25.25,0,0,1-.25-.25V11.75a1.5,1.5,0,0,0-1.5-1.5H14.286a.252.252,0,0,1-.249-.222,2,2,0,0,0-3.975,0,.249.249,0,0,1-.248.222H7.55a1.5,1.5,0,0,0-1.5,1.5V14a.25.25,0,0,1-.25.25H5.05a1,1,0,0,0-1,1Z']],
  BrowserPageText1: ['browser-page-text-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3ZM9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5A.966.966,0,0,1,9.654,3,.969.969,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2Zm-3.5,0A.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5a.969.969,0,0,1-.154.5A.966.966,0,0,1,6.154,3,.969.969,0,0,1,6,2.5.969.969,0,0,1,6.154,2Zm-3.562.092A1,1,0,0,1,3.5,1.5a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5A.966.966,0,0,1,2.654,3,.969.969,0,0,1,2.5,2.5.979.979,0,0,1,2.592,2.092ZM3,22a1,1,0,0,1-1-1V5.25A.25.25,0,0,1,2.25,5h6a.25.25,0,0,1,.25.25v16.5a.25.25,0,0,1-.25.25Zm19-1a1,1,0,0,1-1,1H10.25a.25.25,0,0,1-.25-.25V5.25A.25.25,0,0,1,10.25,5h11.5a.25.25,0,0,1,.25.25Z', 'M12.500 7.250 L19.500 7.250 L19.500 12.750 L12.500 12.750 Z', 'M18.75,15.5h-5.5a.75.75,0,0,0,0,1.5h5.5a.75.75,0,0,0,0-1.5Z', 'M3.5,7.25A.75.75,0,0,0,4.25,8h2a.75.75,0,0,0,0-1.5h-2A.75.75,0,0,0,3.5,7.25Z', 'M4.25,12h2a.75.75,0,0,0,0-1.5h-2a.75.75,0,0,0,0,1.5Z', 'M4.25,16h2a.75.75,0,0,0,0-1.5h-2a.75.75,0,0,0,0,1.5Z', 'M4.25,20h2a.75.75,0,0,0,0-1.5h-2a.75.75,0,0,0,0,1.5Z']],
  Hierarchy: ['hierarchy', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.25,24h11a1.5,1.5,0,0,0,1.485-1.286.249.249,0,0,1,.247-.214H20.25a2,2,0,0,0,2-2V1a1,1,0,0,0-2,0V6a.5.5,0,0,1-.5.5H15.982a.249.249,0,0,1-.247-.214A1.5,1.5,0,0,0,14.25,5h-11a1.5,1.5,0,0,0-1.5,1.5v2A1.5,1.5,0,0,0,3.25,10h11a1.5,1.5,0,0,0,1.485-1.286.249.249,0,0,1,.247-.214H19.75a.5.5,0,0,1,.5.5v4a.5.5,0,0,1-.5.5H15.982a.249.249,0,0,1-.247-.214A1.5,1.5,0,0,0,14.25,12h-11a1.5,1.5,0,0,0-1.5,1.5v2A1.5,1.5,0,0,0,3.25,17h11a1.5,1.5,0,0,0,1.485-1.286.249.249,0,0,1,.247-.214H19.75a.5.5,0,0,1,.5.5v4a.5.5,0,0,1-.5.5H15.982a.249.249,0,0,1-.247-.214A1.5,1.5,0,0,0,14.25,19h-11a1.5,1.5,0,0,0-1.5,1.5v2A1.5,1.5,0,0,0,3.25,24Z']],
  CodeWrite: ['code-write', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    transform: 'translate(-8.097 18.053) rotate(-44.999)'
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.794,23.25h9.06a.488.488,0,0,0,.479-.392l.5-2.5a2,2,0,0,1,.547-1.022l5.268-5.268a.5.5,0,0,0,.146-.353V4.664a1,1,0,0,0-.293-.707L14.087.543A1,1,0,0,0,13.38.25H1.794a1,1,0,0,0-1,1v21A1,1,0,0,0,1.794,23.25Zm2-14.5a.477.477,0,0,1,.45-.5h3.6a.477.477,0,0,1,.45.5v2a.477.477,0,0,1-.45.5h-3.6a.477.477,0,0,1-.45-.5Zm0,5a.477.477,0,0,1,.45-.5h3.6a.477.477,0,0,1,.45.5.25.25,0,0,0,.25.25h2.25a.25.25,0,0,0,.25-.25v-8a.25.25,0,0,0-.25-.25H8.544a.25.25,0,0,0-.25.25.477.477,0,0,1-.45.5h-3.6a.477.477,0,0,1-.45-.5v-2a.477.477,0,0,1,.45-.5h3.6a.477.477,0,0,1,.45.5.25.25,0,0,0,.25.25h2.25a1.752,1.752,0,0,1,1.75,1.75v3a.25.25,0,0,0,.25.25h1.5a.75.75,0,0,1,0,1.5h-1.5a.25.25,0,0,0-.25.25v3a1.752,1.752,0,0,1-1.75,1.75H8.544a.25.25,0,0,0-.25.25.477.477,0,0,1-.45.5h-3.6a.477.477,0,0,1-.45-.5Z', 'M22.223,16.675a.249.249,0,0,0,.353,0l.072-.071A1.914,1.914,0,0,0,19.941,13.9l-.072.071a.25.25,0,0,0,0,.353Z', 'M14.073 16.887 L21.415 16.887 L21.415 20.715 L14.073 20.715 Z', 'M13.392,23.74l1.78-.356a.25.25,0,0,0,.128-.421l-1.718-1.718a.25.25,0,0,0-.422.127l-.356,1.78a.5.5,0,0,0,.49.6A.466.466,0,0,0,13.392,23.74Z']]
};
exports["default"] = _default;